import React, { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export default function AdManager() {
  useEffect(() => {
    // Initialize adsbygoogle only once when component mounts
    if (typeof window !== 'undefined') {
      window.adsbygoogle = window.adsbygoogle || [];
    }
    
    // Clean up any existing ad slots to prevent duplicate initialization
    const cleanup = () => {
      const adSlots = document.querySelectorAll('.adsbygoogle');
      adSlots.forEach(slot => {
        if (slot.hasAttribute('data-adsbygoogle-status')) {
          slot.removeAttribute('data-adsbygoogle-status');
        }
      });
    };
    
    return cleanup;
  }, []);

  return null;
}